import React from 'react';
import { MessageSquare } from 'lucide-react';

// Small visual badge for "this physician has N open support tickets". The
// parent renders a list and is expected to bulk-fetch counts via
// apiClient.getOpenTicketCountsByPhysician(...) and pass each row's count
// down — that avoids one HTTP request per row.

export interface OpenTicketsBadgeProps {
  count: number;
  // Optional click handler — typically a deep-link to /admin/support filtered
  // for this physician.
  onClick?: () => void;
  className?: string;
}

export const OpenTicketsBadge: React.FC<OpenTicketsBadgeProps> = ({ count, onClick, className }) => {
  if (!count || count <= 0) return null;
  const content = (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 ${className ?? ''}`}
      title={`${count} open support ticket${count === 1 ? '' : 's'}`}
    >
      <MessageSquare className="h-3 w-3" />
      {count}
    </span>
  );
  if (!onClick) return content;
  return (
    <button onClick={onClick} className="hover:opacity-80">
      {content}
    </button>
  );
};

export default OpenTicketsBadge;
